<template>
  <div class="form-group col-12 px-0">
    <label for="position">
      {{ label }}
    </label>
    <div class="position-relative">
      <div class="input-group mb-2">
        <input
          v-model="term"
          disabled="disabled"
          type="search"
          :placeholder="placeholder"
          class="form-control"
          @input="search(term)"
        >
      </div>
      <div
        v-if="term && term !== '' && list.length > 0 && open"
        v-click-outside="hide"
        class="bg-white position-relative w-100"
      >
        <div
          class="w-100 list-group rounded-4 position-absolute"
          style="max-height: 250px; overflow-y:scroll; z-index: 80"
        >
          <button
            v-for="(item, index) in list"
            :key="item.name + index"
            type="button"
            class="list-group-item list-group-item-action"
            @click="setItem(item)"
          >
            {{ item.name }}
          </button>
        </div>
      </div>
      <div
        v-if="list.length === 0 && this.term !== null"
        class="invalid-feedback d-flex"
      >
        {{ errorMessage }}
      </div>
    </div>
  </div>
</template>
<script>
import ClickOutside from 'vue-click-outside';
import transform from '@/mixins/transform';

export default {
  name: 'AutoComplete',
  directives: {
    ClickOutside,
  },
  mixins: [transform],
  props: {
    list: {
      type: Array,
      required: true,
      default: () => [],
    },
    resetList: {
      type: Function,
      required: false,
      default: () => {},
    },
    label: {
      type: String,
      required: false,
      default: '',
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Assurup',
    },
    errorMessage: {
      type: String,
      required: false,
      default: 'Aucun résultat',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      term: null,
      open: false,
    };
  },
  methods: {
    search(term) {
      this.$emit('getlist', term);
      this.open = true;
    },
    hide() {
      this.open = false;
    },
    setItem(item) {
      this.open = false;
      this.term = null;
      this.resetList();
      this.$emit('setitem', item);
    },
  },
};
</script>

<style scoped>
button.list-group-item {
  min-height: 80px;
}
button.list-group-item:hover {
  background-color: #EDF4FD;
}
input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  display: none;
}
</style>
